<template>
    <!-- 工作台-待办统计页 -->
    <div class="workbench-work">
        <el-row :gutter="20" v-loading="dataLoading">
            <!-- 待处理数量 -->
            <el-col :sm="12" :md="12" :lg="6">
                <div class="stat-card stat-pending">
                    <div class="stat-label">待处理</div>
                    <div class="stat-num">{{ statsData.pendingCount || 0 }}</div>
                </div>
            </el-col>
            <!-- 已逾期数量 -->
            <el-col :sm="12" :md="12" :lg="6">
                <div class="stat-card stat-overdue">
                    <div class="stat-label">已逾期</div>
                    <div class="stat-num">{{ statsData.overdueCount || 0 }}</div>
                </div>
            </el-col>
            <!-- 今日计划数量 -->
            <el-col :sm="12" :md="12" :lg="6">
                <div class="stat-card stat-today">
                    <div class="stat-label">今日计划</div>
                    <div class="stat-num">{{ statsData.todayPlanCount || 0 }}</div>
                </div>
            </el-col>
            <!-- 本周完成数量 -->
            <el-col :sm="12" :md="12" :lg="6">
                <div class="stat-card stat-week-completed">
                    <div class="stat-label">本周完成</div>
                    <div class="stat-num">{{ statsData.thisWeekCompletedCount || 0 }}</div>
                </div>
            </el-col>
        </el-row>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.keyword" placeholder="请输入待办名称/ 操作内容 / 演出标题" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.assigneeId" filterable remote placeholder="请输入处理人"
                        :remote-method="searchUser" @focus="searchUser('')" :loading="userLoading" size="small" clearable @change="search">
                        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-date-picker v-model="params.timeRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        range-separator="至" start-placeholder="执行计划开始时间" end-placeholder="执行计划结束时间" size="small">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <el-card shadow="never">
            <el-tabs v-model="params.status" size="small" @tab-click="handleTabClick">
                <el-tab-pane :label="`待处理(${statsData.pendingCount || 0})`" name="1"></el-tab-pane>
                <el-tab-pane :label="`已逾期(${statsData.overdueCount || 0})`" name="4"></el-tab-pane>
                <el-tab-pane :label="`已完成(${statsData.completedCount || 0})`" name="2"></el-tab-pane>
                <el-tab-pane :label="`全部(${statsData.totalCount || 0})`" name="-1"></el-tab-pane>
            </el-tabs>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.editRef.show()">新建待办</el-button>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                    <el-table-column prop="statusDesc" label="状态" width="100">
                        <template slot-scope="scope">
                            <el-tag
                                :type="scope.row.status === 1 ? 'danger' : scope.row.status === 2 ? 'success' : 'info'"
                                size="small"
                                disable-transitions
                            >{{ scope.row.statusDesc }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="待办事项">
                        <template slot-scope="scope">
                            <h3>{{scope.row.title}}</h3>
                            <div class="color-info">{{scope.row.content}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="处理人">
                        <template slot-scope="scope">
                            <el-tag v-for="item in scope.row.assignees" :type="item.assigneeStatus == 2 ? 'success' : 'info'" :key="item.assigneeId"
                                size="mini" class="MR5">{{ item.assigneeName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="计划执行时间">
                        <template slot-scope="scope">
                            {{scope.row.deadline}}
                        </template>
                    </el-table-column>
                    <el-table-column label="优先级" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                :type="scope.row.priority === 1 ? 'danger' : scope.row.priority === 2 ? 'warning' : 'info'"
                                size="small"
                                disable-transitions
                            >{{ scope.row.priorityDesc }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="180">
                        <template slot-scope="scope">
                            <!-- 已完成状态不可编辑、不可转派 -->
                            <el-button v-if="scope.row.status != 2" type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.status == 1" type="text" size="small" @click="handleComplete(scope.row)">完成</el-button>
                            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
                            <el-button v-if="scope.row.status != 2" type="text" size="small" @click="handleReassign(scope.row)">转派</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </el-card>
        <edit ref="editRef"></edit>
        <detail ref="detailRef"></detail>
        <complete ref="completeRef" @onSuccess="getPageData"></complete>
        <reassign ref="reassignRef" @onSuccess="getPageData"></reassign>
    </div>
</template>

<script>
import Edit from './components/Edit.vue'
import Detail from './components/Detail.vue'
import Complete from './components/Complete.vue'
import Reassign from './components/Reassign.vue'
const defaultParams = {
    assigneeId: '', // 处理人ID
    deadlineStart: '', // 计划执行时间开始
    deadlineEnd: '', // 计划执行时间结束
    keyword: '', // 关键字搜索（待办名称/ 操作内容 / 演出标题）
    pageNo: 1, // 当前页码
    status: "1", // 状态：1-待处理，2-已完成，3-已取消 4: 已逾期 null: 全部
    timeRange: [], // 时间范围
}
export default {
    name: 'WorkbenchWork',
    components: {
        Edit,
        Detail,
        Complete,
        Reassign,
    },
    data() {
        return {
            // 统计数据
            statsData: {
                totalCount: 0,             // 总数
                pendingCount: 0,           // 待处理数量
                overdueCount: 0,           // 已逾期数量
                todayPlanCount: 0,         // 今日计划数量
                thisWeekCompletedCount: 0, // 本周完成数量
                completedCount: 0,         // 已完成数量
            },
            // 加载状态
            dataLoading: false,
            // 分页数据
            data: null,
            dataList: null,
            // 查询参数
            params: {
                ...defaultParams,
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            // 列表加载状态
            listLoading: true,
            // 用户加载状态
            userLoading: false,
            // 用户列表
            userList: [],
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo || {};
        }
    },
    // 页面挂载后获取统计数据
    mounted() {
        this.setDefaultParams();
        this.getPageData();
    },
    methods: {
        // 设置默认查询参数
        setDefaultParams() {
            // 初始化处理人ID为当前用户ID
            this.params.assigneeId = this.userInfo.id || '';
            this.userList = [{
                id: this.userInfo.id || '',
                name: this.userInfo.name || '',
            }];
        },
        // 设置查询参数
        setParams() {
            // 处理时间范围参数
            if (this.params.timeRange && this.params.timeRange.length) {
                this.params.deadlineStart = this.params.timeRange[0];
                this.params.deadlineEnd = this.params.timeRange[1];
            }
        },
        // 获取页面数据
        getPageData(){
            // 先获取统计数据
            this.getMyStatistics();
            // 再获取分页列表
            this.getDataList();
        },
        // 获取我的待办统计数据
        async getMyStatistics() {
            this.setParams();
            this.dataLoading = true;
            try {
                const res = await this.$request({
                    url: '/pendingtask/myStatistics',
                    method: 'post',
                    data: {
                        ...this.params,
                        status: this.params.status === '-1' ? null : Number(this.params.status),
                    },
                });
                const { state, result } = res.data;
                // 请求成功时更新统计数据
                if (state == 1 && result) {
                    this.statsData = result;
                }
            } catch (err) {
                this.$message.error('获取统计数据失败');
            } finally {
                this.dataLoading = false;
            }
        },
        // 搜索用户
        async searchUser(query) {
            if( !query && this.userList.length > 1 ){
                return;
            }
            this.userLoading = true;
            try {
                const res = await this.$request({
                    url: '/adminUser/list',
                    method: 'post',
                    params: {
                        keyword: query,
                    },
                });
                const { state, result } = res.data;
                // 请求成功时更新用户列表
                if (state == 1 && result) {
                    if( !query ){
                        this.userList = this.userList.concat([...result]);
                    }else{
                        this.userList = result;
                    }
                    // 去重
                    this.userList = this.userList.filter((item, index, self) =>
                        index === self.findIndex(t => t.id === item.id)
                    );
                }
            } catch (err) {
                this.$message.error('搜索用户失败');
            } finally {
                this.userLoading = false;
            }
        },
        // 获取分页列表
        getDataList() {
            this.listLoading = true;
            this.setParams();
            this.$request({
                url: '/pendingtask/pageList',
                method: 'post',
                data: {
                    ...this.params,
                    status: this.params.status === '-1' ? null : Number(this.params.status),
                },
            }).then(res => {
                const { state, result } = res.data;
                // 请求成功时更新待办列表
                if (state == 1 && result) {
                    this.data = result;
                    this.dataList = result.result || [];
                }
            }).finally(() => {
                this.listLoading = false;
            });
        },
        handleTabClick(tab) {
            this.params.status = tab.name;
            this.getDataList();
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getPageData();
        },
        // 编辑待办
        handleEdit(row) {
            this.$refs.editRef.show(row.id);
        },
        // 完成待办
        handleComplete(row) {
            this.$refs.completeRef.open(row);
        },
        // 查看详情
        handleDetail(row) {
            this.$refs.detailRef.open(row.id);
        },
        // 转派待办
        handleReassign(row) {
            this.$refs.reassignRef.open(row.id);
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.setDefaultParams();
            this.getPageData();
        },
    },
};
</script>

<style lang="scss" scoped>
// 统计卡片通用样式
.stat-card {
    text-align: center;
    padding: 20px 10px;
    border-radius: 6px;
    margin-bottom: 10px;

    // 标签文字
    .stat-label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
    }

    // 数字
    .stat-num {
        font-size: 28px;
        font-weight: bold;
    }
}

// 待处理 - 蓝色
.stat-pending {
    background: #e6f7ff;
    .stat-num {
        color: #1890ff;
    }
}

// 已逾期 - 红色
.stat-overdue {
    background: #fff1f0;
    .stat-num {
        color: #ff4d4f;
    }
}

// 今日计划 - 橙色
.stat-today {
    background: #fff7e6;
    .stat-num {
        color: #fa8c16;
    }
}

// 本周完成 - 绿色
.stat-week-completed {
    background: #f6ffed;
    .stat-num {
        color: #52c41a;
    }
}
</style>